import { DocxArtifactPreview } from './docx-artifact-preview';
import { PdfArtifactPreview } from './pdf-artifact-preview';
import { PptxArtifactPreview } from './pptx-artifact-preview';
import { PreviewError } from './preview-state';
import { TextArtifactPreview } from './text-artifact-preview';
import type { ArtifactPreview } from './types';
import { XlsxArtifactPreview } from './xlsx-artifact-preview';

export function ArtifactPreviewContent({
  fitToPaneRequestId,
  onUserZoomChange,
  preview,
}: {
  fitToPaneRequestId: number;
  onUserZoomChange: () => void;
  preview: ArtifactPreview;
}) {
  if (preview.fileType === 'docx') {
    return (
      <DocxArtifactPreview
        fitToPaneRequestId={fitToPaneRequestId}
        onUserZoomChange={onUserZoomChange}
        sourceUrl={preview.sourceUrl}
        title={preview.title}
      />
    );
  }

  if (preview.fileType === 'pdf') {
    return (
      <PdfArtifactPreview
        fitToPaneRequestId={fitToPaneRequestId}
        onUserZoomChange={onUserZoomChange}
        sourceUrl={preview.sourceUrl}
        title={preview.title}
      />
    );
  }

  if (preview.fileType === 'pptx') {
    return <PptxArtifactPreview sourceUrl={preview.sourceUrl} title={preview.title} />;
  }

  if (preview.fileType === 'txt') {
    return <TextArtifactPreview sourceUrl={preview.sourceUrl} title={preview.title} />;
  }

  if (preview.fileType === 'xlsx') {
    return <XlsxArtifactPreview sourceUrl={preview.sourceUrl} title={preview.title} />;
  }

  return <PreviewError message="Unsupported preview type." />;
}
